import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <p>&copy; {currentYear} Wasif Sarwar Siddique. All rights reserved.</p>
    </footer>
  );
};

export default Footer;